import React from 'react'

import { Box, Button, Text } from '@factorialco/deprecated-design-system'
import { ExtraHoursRangeFragment } from 'generated/resources/graphql'

import Popover from 'modules/core/components/PopoverMenu'
import { track, trackingEvents } from 'modules/core/lib/Tracking'
import i18n from 'modules/core/lib/i18n'

import RuleDetails from 'modules/attendance/components/SettingItemPage/TimeTracking/WorkTimeCategories/Content/HoursRules/RuleDetails'
import HoursRulesWizard from 'modules/attendance/components/SettingItemPage/TimeTracking/WorkTimeCategories/Content/HoursRulesWizard'
import { EMPLOYEE_TYPE } from 'modules/attendance/lib/types'

interface Props {
  rule: ExtraHoursRangeFragment
}

const BaseRule = ({ rule }: Props) => {
  const isComplementary = rule.employeeType === EMPLOYEE_TYPE.PART_TIME
  const [openEditModal, setOpenEditModal] = React.useState(false)

  const handleEditClick = () => {
    setOpenEditModal(true)
    track(trackingEvents.timeTracking.baseRuleEditPressed)
  }

  return (
    <>
      <Box
        gap="s16"
        paddingX="s24"
        paddingY="s16"
        borderRadius={{ all: 'abs016' }}
        background="grey100"
        border={{
          all: {
            width: 's1',
            style: 'solid',
            color: 'grey400',
          },
        }}
        onClick={handleEditClick}
      >
        <Box flexDirection="row" justifyContent="spaceBetween" alignItems="center">
          <Text color="grey1000" size="300" weight="semibold">
            {isComplementary
              ? i18n.t(
                  'time_tracking.settings.work_time_categories.complementary_hours_rules.base_rule.complementary_hours'
                )
              : i18n.t(
                  'time_tracking.settings.work_time_categories.extra_hours_rules.base_rule.extra_hours'
                )}
          </Text>
          <Popover type="list">
            <Popover.Trigger>
              <Button type="secondary" iconName="pencil" onClick={handleEditClick} />
            </Popover.Trigger>
          </Popover>
        </Box>
        <RuleDetails rule={rule} />
      </Box>
      {openEditModal && (
        <HoursRulesWizard onClose={() => setOpenEditModal(false)} extraHourRule={rule} />
      )}
    </>
  )
}

export default BaseRule
